module.exports = __webpack_public_path__ + "img/sld_mccb_horizontal.8f8ba98a.svg";